import React, { createContext, useContext, useEffect, useState } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import { useNavigate } from 'react-router-dom';
import module from 'pages/css/moduleStyle.module.css';
import styles from 'pages/css/trfSfty.module.css';
import { ResponsiveBar } from '@nivo/bar';


export const TrafficTotalContext = createContext(null);


export function SwItsGetEvntOneDetailProvider({ crsrdId, children }) {
    const [currentData, setCurrentData] = useState();

    useEffect(() => {
        return repeatEffect(async () => {
            const response = await ApiService.get(
                `newdashboard/trfsfty/GetEvntCrsrd?CrsrdId=${crsrdId}`
            );

            if (response.status === 200) {
                const data = response.data;

                setCurrentData({
                    updateTime: data.updateTime,
                    totalCount: data.totalCount,
                    diffPct: data.diffPct,
                    todayEvnt: data.todayEvnt,
                    monthEvnt: data.monthEvnt,
                    acsr: data.acsr

                });
            }
        }, settingsConfig().contentUpdateDelaySec);
    }, [crsrdId]);

    return (
        <TrafficTotalContext.Provider value={currentData}>
            {children}
        </TrafficTotalContext.Provider>
    );
}


export function SwItsGetEvntOneDetailCrsrdName() {

    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;
    const crsrdName = currentData.todayEvnt?.[0]?.crsrdNm ?? '';

    return (
        <>
            <h3 className='boxTit'>{crsrdName}</h3>
        </>
    );
}

// 안전모듈 상세 - 접근로 이름 + 사진 
export function SwItsGetEvntOneDetailInfo() {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    const crsrdName = currentData.todayEvnt?.[0]?.crsrdNm ?? '';

    // 필요한 값들
    const eventData = {
        crsrdName,
    };

    // 기본 이미지 목록
    const defaultImages = [
        '/images/crsrd/underpass.png',
        '/images/crsrd/norim4way.png',
        '/images/crsrd/elementary.png',
        '/images/crsrd/kindergarten.png'
    ];

    // currentData.acsr가 있다면 그걸로 cameraList 생성
    const cameraList = currentData.acsr?.map((acsrItem, idx) => ({
        name: acsrItem.drctNm,
        imgUrl: defaultImages[idx] ?? '/images/crsrd/default.png'
    })) ?? [];

    return (
        <>
            <ul className={`${module.cameraList} cst_scroll`}>
                {cameraList.map((list) => (
                    <li key={list.name} className={`${module.gap20} ${module.cameraListTit} flx flx_col`} >
                        <div className="flx j_spc_btw a_center">
                            {list.name} 방면
                        </div>
                        <div className='flx_1'>
                            <a className={`${module.imgWrapper}`} href={list.imgUrl} target="_blank" rel="noopener noreferrer">
                                <img src={list.imgUrl} alt={list.name} className={module.cameraImage} />
                            </a>
                        </div>
                    </li>
                ))}
            </ul>
        </>
    );
}

const RESPONSE_MAP = {
    '역주행': ['노면표지, 안내판, 차단봉 설치 권장'],
    '무단횡단': ['보행펜스 설치 ', '보행신호 연장 권장'],
    '정지차량': ['돌발상황 전파 ', '차로 유도선 표시 권장'],
    '사고': ['돌발상황 전파 ', '신속대응 권장'],
    '정지선 위반': ['정지선 재조정 권장'], 
    '꼬리물기': ['노면표지 강화 ', '신호연계 최적화 권장'],
};

// 안전모듈 상세 , 대응방안 + 교차로 이름 
export function SwItsGetEvntOneDetailCounter({ activeId }) {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    const crsrdName = currentData.todayEvnt?.[0]?.crsrdNm ?? '';

    const defaultItems = [
        '정지선위반'
    ];

    // activeId가 '전체'일 때는 itemsToShow를 빈 배열로 설정
    const itemsToShow = activeId === '전체' || !RESPONSE_MAP[activeId] ? [] : [activeId];
    

    return (
        <>
            {itemsToShow.length > 0 && (
                <div className={`${module.subBox} ${module.gap20} innerBg flx flx_col`}>
                    <p>권장 대응 방안</p>
                    <ul className="flx a_center">
                        {itemsToShow.map((item) => (
                            <li key={item}>
                                {item} 대응 :{' '}
                                <span className={`${module.alert50}`}>
                                    {RESPONSE_MAP[item]?.join(', ')}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </>
    );
}

//  교차로 위험행동 내림차순 정렬 
export function SwItsGetEvntOneDetailEvnt({ activeId, setActiveId }) {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    const allEvents = currentData.todayEvnt ?? [];

    const EVENT_CODE_MAP = {
        4358: '정지선 위반',
        4450: '꼬리물기',
        4418: '정지차량',
        4417: '역주행',
        4387: '무단횡단',
        4595: '사고',
    };

    const colorMap = {
        4358: 'var(--chart-05)', // 정지선 위반
        4450: 'var(--chart-06)', // 꼬리물기
        4418: 'var(--chart-07)', // 정지차량
        4417: 'var(--alert-50-80)', // 역주행
        4387: 'var(--chart-02)', // 무단횡단
        4595: 'var(--chart-03)', // 사고
    };

    const fixedTargetCodes = [4358, 4450, 4418, 4417, 4387, 4595];

    const categorizedEvents = fixedTargetCodes.map(code => {
        const match = allEvents.find(e => Number(e.cd) === code);
        return {
            cd: code,
            cdNm: EVENT_CODE_MAP[code] || `코드 ${code}`,
            count: match?.count || 0, 
        };
    });

    const totalCount = categorizedEvents.reduce((sum, ev) => sum + ev.count, 0);

    const eventListWithTotal = [{ cdNm: '전체', count: totalCount }, ...categorizedEvents.sort((a, b) => b.count - a.count)];

    return (
        <div className={`flx flx_col ${module.gap20}`} style={{ height: '100%' }}>
            {/* <h3 className={`${module.subTitle}`}>교차로 위험행동</h3> */}
            <ul className={`${styles.dangerAct}`}>
                {eventListWithTotal.map((list, idx) => {
                    // 배경 색상 설정
                    const bgColor = colorMap[list.cd] || 'var(--white-50)'; // 기본 색상
                    const isActive = activeId === list.cdNm;

                    return (
                        <li
                            key={list.cdNm}
                            className={`${isActive ? styles.active : ''} ${styles.selectList}`}
                            onClick={() => setActiveId(list.cdNm)}
                        >
                            <button type="button" className="flx j_spc_btw a_center">
                                <div className={`${module.bg}`} style={{ backgroundColor: bgColor }}>
                                    {list.cdNm}
                                </div>
                                <div className="flx a_flx_end">
                                    <span>{list.count?.toLocaleString()}</span>건
                                </div>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}


// 위험행동 통계 
export function SwItsGetEvntOneDetailStatistics() {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    const pointResult = [
        {
            title: '전체',
            data: currentData.totalCount,
            unit: '건/시',
            color: 'alert50'
        },
        {
            title: '전년동월대비',
            data: currentData.diffPct,
            unit: '%',
            word: <span className={module.ft48}>감소</span>
        }
    ];
    return (
        <>
            <ul className={`${styles.point} flx j_center innerBg`}>
                {pointResult.map((list) => (
                    <li key={list.title}>
                        <div className='subTit'>{list.title}</div>
                        <div className="flx a_flx_end">
                            <span className='nbr'>{list.data?.toLocaleString()}</span>
                            <span className={`${styles.subTxt_trfSfty} subTxt`}>{list.unit}</span>
                            <span className={`${styles.subTxtPoint_trfSfty} subTxt`}>{list.word}</span>
                        </div>
                    </li>
                ))}
            </ul>
        </>
    );
}


// CCTV 포착화면 
export function SwItsGetEvntOneDetailCctvCapture({ activeId }) {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    const todayEvents = currentData.todayEvnt ?? [];

    const MAX_CAPTURE_COUNT = 10;

    const cctvCapture = [
        { name: '역주행', img: '/images/event/ReverseRun.jpg' },
        { name: '무단횡단', img: '/images/event/jaywalking.jpg' },
        { name: '정지차량', img: '/images/event/stopVeh.png' },
        { name: '사고', img: '/images/event/accident.png' },
        { name: '정지선 위반', img: '/images/event/stopLineViolation.jpg' },
        { name: '꼬리물기', img: '/images/event/Tailgating.jpg' },
    ];

    const getMatchedCapture = (name) => cctvCapture.find((item) => item.name === name);

    const displayList = activeId === '전체'
        ? cctvCapture
        : (() => {
            const found = todayEvents.find((ev) => ev.cdNm === activeId);
            if (!found || found.count === 0) return [];

            const matched = getMatchedCapture(activeId);
            if (!matched) return [];

            const count = Math.min(found.count, MAX_CAPTURE_COUNT);
            return Array.from({ length: count }, () => matched);
        })();

    return (
        <>
            <div className={`${module.gap20} flx flx_col`}>
                <h3 className={`${module.subTitle}`}>CCTV 포착 화면</h3>
                <ul className={`${module.cctvCapture} flx cst_scroll`}>
                    {displayList.map((item, idx) => (
                        <li key={`${item.name}-${idx}`} className="flx flx_col">
                            <div className="innerBg">{item.name}</div>
                            {item.img ? (
                                <img src={item.img} alt={item.name} />
                            ) : (
                                <div className="noImage">최근 내역 없음</div>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
}

const getFilteredMonthData = (data, activeId) => {
    if (activeId === '전체') {
        // 월별로 전체 이벤트 합산
        const monthMap = {};

        data.monthEvnt.forEach((item) => {
            const mm = `${item.mm.slice(2, 4)}월`;
            if (!monthMap[mm]) {
                monthMap[mm] = 0;
            }
            monthMap[mm] += item.count;
        });

        return Object.entries(monthMap).map(([mm, count]) => ({ mm, count }));
    }

    // 특정 이벤트만 필터링
    return data.monthEvnt
        .filter((item) => item.cdNm === activeId)
        .map((item) => ({
            mm: `${item.mm.slice(2, 4)}월`,
            count: item.count,
        }));
};

export function SwItsGetEvntOneDetailChart({ activeId }) {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData || !activeId) return null;

    const chartData = getFilteredMonthData(currentData, activeId);

    if (chartData.every((item) => item.count === 0)) {
        return (
          <p style={{ fontSize: '50px', color: '#fff' }}>
            해당 이벤트의 월별 데이터가 없습니다.
          </p>
        );
      }
    // 최대값 계산해서 5등분
    const maxCount = Math.max(...chartData.map((d) => d.count));
    const tickValues = Array.from({ length: 6 }, (_, i) => Math.round((maxCount / 5) * i));

    return (
        <div style={{ width: '100%', height: 980 }}>
            <ResponsiveBar
                data={chartData}
                keys={['count']}
                indexBy="mm"
                margin={{ top: 20, right: 30, bottom: 50, left: 40 }}
                padding={0.3}
                colors={() => '#394CFF'}
            //    barComponent={RoundedBar}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: '월',
                    legendPosition: 'middle',
                    legendOffset: 32,
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: '건수',
                    legendPosition: 'middle',
                    legendOffset: -30,
                    tickValues: tickValues,
                }}
                gridYValues={tickValues}
                tooltip={({ indexValue, value }) => (
                    <strong>{indexValue} : {value}건</strong>
                )}
                animate={true}
                enableLabel={false}
                theme={{
                    axis: {
                        ticks: {
                            text: {
                                fontSize: 20,
                                fill: 'var(--white-80)',
                                fontWeight:'normal' // X축 폰트 색상 검정
                            },
                        },
                    },
                    tooltip: {
                        container: {
                            fontSize: '13px',
                        },
                    },
                }}
            />
        </div>
    );
}